import { useClickAway } from "@uidotdev/usehooks";
import { Popover } from "antd";
import React, { useEffect, useRef, useState } from "react";
// import greySeachIcon from "../../../../../images/search_grey.svg";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { FolderOpen } from "@/Components/Icons/FolderOpen";
import { routingConstants } from "@/Constants/routingConstants";
import {
  fetchTopSearchResults,
  toggleTopSearchLoading,
  updateTopSearch,
  updateTopSearchResults,
} from "@/reducers/clientcommon";
import useDebounceSearch from "@/utilities/hooks/useDebounceSearch";

import TableLoader from "../../TableLoader";
import ActionIcons from "../ActionIcons";
import SearchSkeleton from "./SearchSkeleton";
import { apiEncrypt } from "../../../../utilities/keyEncryption";
import { SearchIcon } from "../../../Icons/SearchIcon";
import NoAccessButtonWrapper from "../UserRoleAccess/NoAccessButtonWrapper";

/**
 * Function component for displaying and handling top search functionality.
 *
 * @return {JSX.Element} The JSX element representing the top search component.
 */
const TopSearch = () => {
  const { topSearch, topSearchResults, topSearchLoading } = useSelector(
    (state) => state.clientCommon,
  );
  const { isPremiumAccount, clientUserAllPermissions } = useSelector(
    (state) => state.session,
  );

  const ref = useClickAway(() => {
    setShowTopSearch(false);
  });
  const dispatch = useDispatch();
  const [showTopSearch, setShowTopSearch] = useState(false);
  const topSearchRef = useRef(null);
  const [inputFocused, setInputFocused] = useState(false);
  const debouncedTopSearch = useDebounceSearch(topSearch, 550); // 600ms delay

  useEffect(() => {
    if (
      clientUserAllPermissions.is_allow_to_global_search === 0 ||
      clientUserAllPermissions === "undefined"
    ) {
      return;
    }

    if (debouncedTopSearch && debouncedTopSearch.trim() != "") {
      setShowTopSearch(true);
      dispatch(toggleTopSearchLoading(true));
      dispatch(
        fetchTopSearchResults({
          keyword: debouncedTopSearch,
        }),
      );
    }
    if (debouncedTopSearch == "") {
      dispatch(updateTopSearch(""));
      dispatch(toggleTopSearchLoading(false));
      dispatch(updateTopSearchResults([]));
    }
  }, [debouncedTopSearch]);

  /**
   * Generates the route based on the type and id.
   *
   * @param {string} type - the type of route
   * @param {string} id - the id of the route
   * @return {string} the generated route
   */
  const topSearchRoute = (type, id) => {
    const routes = {
      Worked: id ? routingConstants.candidateDetail(id) : null,
      Booked: id ? routingConstants.candidateDetail(id) : null,
      Invited: routingConstants.invitedCandidate,
      Applied: id ? routingConstants.candidateDetail(id) : null,
      Invoiced: id ? routingConstants.candidateDetail(id) : null,
      Contract: id ? routingConstants.contractDetail(id) : null,
      Registered: id ? routingConstants.candidateDetail(id) : null,
    };
    return id == null ? null : routes[type];
  };
  return (
    <>
      {clientUserAllPermissions?.is_allow_to_global_search === 0 ? (
        <NoAccessButtonWrapper
          // key={ele.name}
          rootClass="rounded-lg w-[500px]"
          iconClass="w-[23px] h-[23px] text-primary"
          _checkPermission={["is_allow_to_global_search"]}
        >
          <Popover
            content={
              <>
                <div className="TopSearchDropdown_Wrapper" ref={ref}>
                  <div
                    className="custom-scrollbar-ui max-h-[408px] overflow-auto rounded-lg bg-white shadow-[0px_1px_9px_0px_rgba(0,0,0,0.15)] [&>*:last-child]:border-b-0 [&>*]:border-0 [&>*]:border-b [&>*]:border-b-lightblue"
                    style={{
                      width: `${topSearchRef.current?.offsetWidth}px`,
                    }}
                  >
                    {topSearchLoading ? (
                      <div className="p-4">
                        <TableLoader />
                      </div>
                    ) : topSearchResults.length === 0 && topSearch ? (
                      <>
                        <div className="flex h-[408px] flex-col items-center justify-center gap-3">
                          <div className="grid h-[80px] w-[80px] place-items-center rounded-full bg-lightblue">
                            <FolderOpen cls="w-[50px] h-[50px] text-primary" />
                          </div>
                          <span className="text-[18px] font-semibold leading-[normal] text-[#808396]">
                            No Data
                          </span>
                        </div>
                      </>
                    ) : (
                      <>
                        {topSearchResults.map((item, index) => {
                          const { id, type_ref_no, name, type } = item;
                          let encryptedId = apiEncrypt(id);
                          return (
                            <Link
                              key={id || `${type}-${index}`}
                              to={topSearchRoute(type, encryptedId)}
                              className="block px-4 py-3 transition-all duration-200 ease-linear hover:bg-grey"
                              target="_blank"
                              onClick={() => {
                                setShowTopSearch(false);
                                dispatch(updateTopSearch(""));
                              }}
                            >
                              <div className="flex flex-col">
                                <div className="flex gap-[7px]">
                                  {type !== `Invited` ? (
                                    <h3 className="text-[14px] font-semibold leading-[normal] text-primary">
                                      {type_ref_no}
                                    </h3>
                                  ) : null}
                                  <p className="text-[14px[ font-semibold leading-[normal] text-txtDark">
                                    {name}
                                  </p>
                                </div>
                                <span className="text-[12px] font-semibold leading-[normal] text-txtColor">
                                  In {type}
                                </span>
                              </div>
                            </Link>
                          );
                        })}
                      </>
                    )}
                  </div>
                </div>
              </>
            }
            // trigger="click"
            arrow={false}
            open={showTopSearch}
            placement="bottomRight"
          >
            <div
              className={`tour-header-main-search TopSeach_Wrapper relative flex h-[44px] max-w-[500px] grow items-center gap-[10px] rounded-lg border bg-grey px-4 transition-[border] duration-200 ease-linear xl:max-w-[575px] ${inputFocused ? "border-primary" : "border-grey"}`}
              ref={topSearchRef}
            >
              <SearchIcon cls="w-[24px] h-[24px] text-primary" />

              <input
                type="text"
                autoComplete="off"
                aria-autocomplete="off"
                placeholder="Search anything"
                className="!focus:shadow-none h-[22px] w-full rounded-none !border-none bg-none p-0 pr-6 text-[16px] font-normal text-black !outline-none !ring-0"
                value={topSearch}
                onChange={(e) => dispatch(updateTopSearch(e.target.value))}
                onFocus={() => {
                  setInputFocused(true);
                  if (topSearchResults.length > 0) {
                    setShowTopSearch(true);
                  }
                }}
                onBlur={() => setInputFocused(false)}
              />

              {topSearch !== "" ? (
                <button
                  className="absolute right-2 top-1/2 -translate-y-1/2 transform"
                  onClick={() => dispatch(updateTopSearch(""))}
                >
                  <ActionIcons type="reject" isLoading={false} />
                </button>
              ) : null}
            </div>
          </Popover>
        </NoAccessButtonWrapper>
      ) : (
        <Popover
          content={
            <>
              <div className="TopSearchDropdown_Wrapper" ref={ref}>
                <div
                  className="custom-scrollbar-ui max-h-[408px] overflow-auto rounded-lg bg-white shadow-[0px_1px_9px_0px_rgba(0,0,0,0.15)] [&>*:last-child]:border-b-0 [&>*]:border-0 [&>*]:border-b [&>*]:border-b-lightblue"
                  style={{
                    width: `${topSearchRef.current?.offsetWidth}px`,
                  }}
                >
                  {topSearchLoading ? (
                    Array.from({ length: 1 }).map((_, index) => (
                      <div key={index}>
                        <div className="p-3">
                          <SearchSkeleton />
                        </div>
                      </div>
                    ))
                  ) : topSearchResults.length === 0 && topSearch ? (
                    <>
                      <div className="flex h-[408px] flex-col items-center justify-center gap-3">
                        <div className="grid h-[80px] w-[80px] place-items-center rounded-full bg-lightblue">
                          <FolderOpen cls="w-[50px] h-[50px] text-primary" />
                        </div>
                        <span className="text-[18px] font-semibold leading-[normal] text-[#808396]">
                          No Data
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      {topSearchResults.map((item, index) => {
                        const { id, type_ref_no, name, type } = item;
                        let encryptedId = apiEncrypt(id);
                        return (
                          <Link
                            key={id || `${type}-${index}`}
                            to={topSearchRoute(type, encryptedId)}
                            className="block px-4 py-3 transition-all duration-200 ease-linear hover:bg-grey"
                            target="_blank"
                            onClick={() => {
                              setShowTopSearch(false);
                              dispatch(updateTopSearch(""));
                            }}
                          >
                            <div className="flex flex-col">
                              <div className="flex gap-[7px]">
                                {type !== `Invited` ? (
                                  <h3 className="text-[14px] font-semibold leading-[normal] text-primary">
                                    {type_ref_no}
                                  </h3>
                                ) : null}
                                <p className="text-[14px[ font-semibold leading-[normal] text-txtDark">
                                  {name}
                                </p>
                              </div>
                              <span className="text-[12px] font-semibold leading-[normal] text-txtColor">
                                In {type}
                              </span>
                            </div>
                          </Link>
                        );
                      })}
                    </>
                  )}
                </div>
              </div>
            </>
          }
          // trigger="click"
          arrow={false}
          open={showTopSearch}
          placement="bottomRight"
        >
          <div
            className={`tour-header-main-search TopSeach_Wrapper relative flex h-[44px] max-w-[500px] grow items-center gap-[10px] rounded-lg border bg-grey px-4 transition-[border] duration-200 ease-linear xl:max-w-[575px] ${inputFocused ? "border-primary" : "border-grey"}`}
            ref={topSearchRef}
          >
            <SearchIcon cls="w-[24px] h-[24px] text-primary" />

            <input
              type="text"
              autoComplete="off"
              aria-autocomplete="off"
              placeholder="Search anything"
              className="!focus:shadow-none h-[22px] w-full rounded-none !border-none bg-none p-0 pr-6 text-[16px] font-normal text-black !outline-none !ring-0"
              value={topSearch}
              onChange={(e) => dispatch(updateTopSearch(e.target.value))}
              onFocus={() => {
                setInputFocused(true);
                if (topSearchResults.length > 0) {
                  setShowTopSearch(true);
                }
              }}
              onBlur={() => setInputFocused(false)}
            />

            {/* <input
                type="text"
                autoComplete="off"
                aria-autocomplete="off"
                placeholder="Search anything"
                className="!focus:shadow-none text-black h-[22px] w-full rounded-none !border-none bg-none p-0 text-[16px] font-normal !outline-none !ring-0 pr-6"
                value={topSearch}
                onChange={(e) => dispatch(updateTopSearch(e.target.value))}
                onFocus={() => {
                  setInputFocused(true);
                  if (topSearchResults.length > 0) {
                    setShowTopSearch(true);
                  }
                }}
                onBlur={() => setInputFocused(false)}
              /> */}
            {topSearch !== "" ? (
              <button
                className="absolute right-2 top-1/2 -translate-y-1/2 transform"
                onClick={() => dispatch(updateTopSearch(""))}
              >
                <ActionIcons type="reject" isLoading={false} />
              </button>
            ) : null}
          </div>
        </Popover>
      )}
    </>
  );
};

export default TopSearch;
